import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import {
  closedDrawerWidth,
  drawerWidth,
} from "components/Sidebar/SidebarDrawer";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles<
  OLTheme,
  { isSidebarOpen: boolean; informationsHeight: number }
>((theme: OLTheme) =>
  createStyles({
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: theme.spacing(12),
      margin: theme.spacing(0, -9.5),
      padding: theme.spacing(8, 10),
      borderBottom: `1px solid ${theme.gray100}`,
      position: "fixed",
      top: ({ informationsHeight }) => `${informationsHeight}px`,
      zIndex: 4,
      background: theme.white00,
      width: ({ isSidebarOpen }) =>
        `calc(100vw - ${isSidebarOpen ? `${drawerWidth}px` : `${closedDrawerWidth}px`})`,
      transition: theme.transitions.create(["width", "top"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    flexWrapper: {
      display: "flex",
      alignItems: "center",
    },
    headerButtonsWrapper: {
      display: "flex",
      alignItems: "stretch",
      height: 29.5,
    },
    title: {
      maxWidth: "700px",
      margin: theme.spacing(0, "auto", 0, 0),
      "[dir='rtl'] &": {
        margin: theme.spacing(0, 0, 0, "auto"),
      },
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.gray800,
      overflow: "hidden",
      textOverflow: "ellipsis",
      textWrap: "nowrap",
    },
    breadcrumbLink: {
      color: theme.gray500,
      textDecoration: "none",
    },
    item: {
      minWidth: "20px",
      padding: 0,
      textTransform: "none",
      textDecoration: "none",
      color: theme.gray500,
      fontSize: "14px",
      fontWeight: "400",
      "&:hover": {
        backgroundColor: "inherit",
        color: theme.gray500,
      },
      "& span": {
        marginLeft: 0,
      },
    },
    icon: {
      width: "20px",
      height: "20px",
      color: theme.gray500,
      stroke: theme.gray500,
      "& path": {
        strokeWidth: "1.5px",
      },
    },
    avatar: {
      width: "24px",
      height: "24px",
      backgroundColor: "#D68C47",
      fontSize: "12px !important",
      fontWeight: 400,
      lineHeight: "18px",
    },
    logout: {
      backgroundColor: theme.red100,
      color: theme.red500,
      "&:hover": {
        backgroundColor: theme.red100,
      },
    },
    gapLarge: {
      gap: theme.spacing(8),
    },
    gapSmall: {
      gap: theme.spacing(4),
    },
    backIcon: {
      minWidth: 24,
      margin: 0,
    },
    hiddenOverflow: {
      overflow: "hidden",
    },
    ellipsisText: {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
    mediaContainer: {
      "@media (max-width: 1100px)": {
        maxWidth: 600,
      },
    },
    verticalSeparator: {
      width: "1px",
      height: "100%",
      position: "relative",
    },
    separator: {
      position: "absolute",
      top: "-16px",
      width: "1px",
      height: "calc(100%  + 32px)",
      backgroundColor: theme.gray100,
    },
  }),
);
